import { addMinutes, format } from 'date-fns'
import React from 'react'
import CreateNewEventEmptyGridBox from './CreateNewEventEmptyGridBox'
import LargeWeekViewAvailabilityPlaceholderChip from './LargeWeekViewAvailabilityPlaceholderChip'
import LargeWeekViewEventChips from "./LargeWeekViewEventChips"
import LargeWeekViewHorizontalLines from "./LargeWeekViewHorizontalLines"
import LargeWeekViewVerticalLines from "./LargeWeekViewVerticalLines"
import { convertStringToUTCString } from '../calendarFunctions'

const LargeWeekViewCalendar = ({containerOffset, weekViewEventObject, setEditEvent, setEventToEdit, displayedWeek, createNewCalendarEvent, schoolCalendar}) => {
  const [finalDateObject, setFinalDateObject] = React.useState(weekViewEventObject)

  React.useEffect(() => createColumns(), [weekViewEventObject, displayedWeek])

  const createColumns = () => {
    const events = [...weekViewEventObject];
    const hash = {};
    let columns = 1;

  
    events.forEach((event) => {
      const time = new Date(event.dateTime).getTime();
      if (hash[time]) {
        hash[time]++;
        columns = Math.max(columns, hash[time]);
        event.column = hash[time];
      } else {
        hash[time] = 1;
        event.column = 1;
      }
    });
  
    setFinalDateObject(events);
  };

  const createNewEventByClickBlankSpace = (col, i) => {
    let fixedColumn = col === 0 ? 6 : col - 1
    let formattedDateTime = format(addMinutes(displayedWeek[fixedColumn], (i - 3) * 5), "yyyy-MM-dd'T'HH:mm:ss")
    createNewCalendarEvent(convertStringToUTCString(formattedDateTime, schoolCalendar.timeZone))
  }

    return(
        <div className="flex flex-auto z-0">
          <div className="sticky left-0 z-10 w-14 flex-none bg-white ring-1 ring-gray-100" />
          <div className="grid flex-auto grid-cols-1 grid-rows-1">
            <LargeWeekViewHorizontalLines containerOffset={containerOffset} />
            <LargeWeekViewVerticalLines />
            <ol className={`col-start-1 col-end-2 row-start-1 grid grid-cols-1 mt-1 sm:grid-cols-7 sm:pr-0`} style={{ gridTemplateRows: 'repeat(288, 12px) auto' }}>
              {Array.from(Array(288), (e, i) => (
                <CreateNewEventEmptyGridBox key={i} i={i} createNewEventByClickBlankSpace={createNewEventByClickBlankSpace} />
              ))}
              {finalDateObject.map((event) => 
                event.isAvailabilityPlaceholder ? 
                <LargeWeekViewAvailabilityPlaceholderChip key={event.id} event={event} />
                :
                <LargeWeekViewEventChips key={event.id} event={event} setEditEvent={setEditEvent} setEventToEdit={setEventToEdit} />
                )}
            </ol>
          </div>
        </div>
    )
}
export default LargeWeekViewCalendar;